import Marquee from "react-fast-marquee";
import { useLang } from "@/i18n/LanguageContext";

export const CauseMarquee = () => {
  const { t } = useLang();
  const items = t("marquee");
  return (
    <section data-testid="marquee-section" className="py-10 border-y border-border bg-secondary/20 overflow-hidden">
      <Marquee speed={30} gradient={false} autoFill>
        {items.map((tx, i) => (
          <span key={i} className="mx-8 font-serif text-3xl sm:text-5xl text-foreground/85 flex items-center gap-8">
            {tx}
            <span className="text-primary text-2xl sm:text-3xl">✦</span>
          </span>
        ))}
      </Marquee>
    </section>
  );
};
